// オンボーディングツアーの各ステップ定義。
// selector は対象 UI を指す CSS セレクタ（既存の aria-label を再利用＝実装詳細に依存しない）。
// 見つからない場合は中央表示にフォールバックする（OnboardingTour 側で処理）。
export interface OnboardingStep {
    selector?: string;
    title: string;
    body: string;
}

export const ONBOARDING_STEPS: OnboardingStep[] = [
    {
        title: 'ようこそ',
        body: 'このツアーで主要な操作を順に紹介します。いつでもスキップでき、後からヘルプ（右上の ? アイコン）で再生できます。',
    },
    {
        selector: '[aria-label="サイドナビの開閉"]',
        title: 'メニューの開閉',
        body: '左のサイドナビから R / L 各ツールの画面に移動できます。このボタンで開閉します（ショートカット: B）。',
    },
    {
        selector: '[aria-label="ワークフロー"]',
        title: '進行状況',
        body: '計算セット準備 → データ登録 → 計算 → 結果 のどこにいるかを示します。各ステップをクリックで移動できます（[ / ] でも移動）。',
    },
    {
        selector: '[aria-label="パワートレイン切替"]',
        title: 'BEV / HEV 切替',
        body: '解析対象のパワートレインを切り替えます。ヘッダーの差し色で現在のモードが分かります。',
    },
    {
        selector: '[aria-label="ユーザーメニュー"]',
        title: 'テーマとログアウト',
        body: 'アバターからテーマ変更（ショートカット: T）やログアウトができます。',
    },
    {
        selector: '[aria-label="ヘルプ"]',
        title: 'ヘルプ',
        body: 'ここからショートカット一覧（?）やこのツアーをいつでも開けます。⌘K / Ctrl+K でコマンドパレットも使えます。',
    },
];
